import React from 'react';
import './style.scss';
import { SymbolDetailInfo, OverseasRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';
import {
  JPDateFormatType,
  formatJPDate,
  formatPrice,
  formatYenBasedOn10KYen,
  formatYenBasedOn1MYen,
} from 'views/utils/converter';
import { DomesticRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';
export const LeaseFundFullInfo = (symbolDetail: SymbolDetailInfo) => {
  return (
    <div className="leaseFund">
      <div className="fullInfo">
        <LeaseFundMainData {...symbolDetail} />
        <LeaseFundSubData {...symbolDetail} />
        <PurchaseOption {...symbolDetail} />
      </div>
    </div>
  );
};
const LeaseFundMainData = (symbolDetailInfo: SymbolDetailInfo) => {
  const regex = /\d{1,2}日/g;
  return (
    <>
      <div className="mainData">
        <div className="mainData_wrapper item1">
          <span className="mainData_wrapper_head">損益分配日</span>
          <span className="mainData_wrapper_data medium">
            {symbolDetailInfo.PaLDistMonth.map((m) => (
              <span>
                {m}
                {!regex.test(m) && '末日'}
              </span>
            ))}
          </span>
        </div>
        <div className="mainData_wrapper item2">
          <span className="mainData_wrapper_head">初年度損金算入率</span>
          <span className="mainData_wrapper_data small">
            <GetMaxFirstYearDeductionRate {...symbolDetailInfo} />
          </span>
        </div>
      </div>
    </>
  );
};
const LeaseFundSubData = ({ LeaseStartDate, TotalInvestmentAmount, MinimumInvestmentAmount }: SymbolDetailInfo) => {
  return (
    <>
      <div className="subData">
        <div className="subData_head">
          <span>リース開始日</span>
          <span>出資金総額</span>
          <span>最低出資額</span>
        </div>
        <div className="subData_data">
          <span>{formatJPDate(LeaseStartDate, JPDateFormatType.YMD)}</span>
          <span>{formatYenBasedOn1MYen(TotalInvestmentAmount)}</span>
          <span>{formatYenBasedOn10KYen(MinimumInvestmentAmount)}</span>
        </div>
      </div>
    </>
  );
};
export const PurchaseOption = ({ PurchaseOptions }: SymbolDetailInfo) => {
  const maxPurchaseOptionsLength = 3;
  return (
    <>
      <div className="purchaseOption">
        <div className="purchaseOption_label">購入選択権設定日　※2</div>
        <div className="purchaseOption_date">
          {(() => {
            const items = [];
            for (let i = 0; i < maxPurchaseOptionsLength; i++) {
              items.push(
                i < PurchaseOptions.length ? (
                  <div>
                    {getRoundNumString(i)}
                    {formatJPDate(PurchaseOptions[i]?.Date, JPDateFormatType.YMD)}（{PurchaseOptions[i]?.Elapsed}）
                  </div>
                ) : (
                  <br />
                ),
              );
            }
            return items;
          })()}
        </div>
      </div>
    </>
  );
};
export const FirstYearDeductionRate = (symbolDetailInfo: SymbolDetailInfo) => {
  return (
    <>
      <div className="firstYearDeductionRate">
        <div className="firstYearDeductionRate_label">初年度損金算入率</div>
        <div className="firstYearDeductionRate_date">
          <GetMaxFirstYearDeductionRate {...symbolDetailInfo} />
        </div>
      </div>
    </>
  );
};
const GetMaxFirstYearDeductionRate = ({ FirstYearDeductionRate }: SymbolDetailInfo) => {
  return FirstYearDeductionRate.map((rate) => <div>{rate}</div>);
};
const roundNumStrings = '①②③④⑤⑥⑦⑧⑨⑩';
const getRoundNumString = (num: number) => {
  return roundNumStrings[num];
};

export const DomesticRealEstateFullInfo = (symbolDetail: DomesticRealEstateSymbolDetailInfo) => {
  return (
    <div className="domesticRealEstateItExplanation">
      <div className="fullInfo">
        <div className="mainLabel">
          <DomesticRealEstateMainLabel headList={['販売単位']} dataList={symbolDetail.SalesUnit!.split('\n')} />
          <DomesticRealEstateMainLabel
            headList={['販売総個数']}
            dataList={[`総個数: ${formatPrice(symbolDetail.TotalSalesQuantity)}個`]}
          />
          <DomesticRealEstateMainLabel
            headList={['表面利回り', '（税抜）']}
            dataList={symbolDetail.GrossYield!.split('\n')}
          />
          <DomesticRealEstateMainLabel
            headList={['配当利回り', '（税抜）']}
            dataList={symbolDetail.DividendYield!.split('\n')}
          />
          <DomesticRealEstateMainLabel headList={['配当']} dataList={symbolDetail.DividendPeriod!.split('\n')} />
          <DomesticRealEstateMainLabel
            headList={['相続税評価　圧縮率']}
            dataList={symbolDetail.CompressionRate!.split('\n')}
          />
          <DomesticRealEstateMainMap headList={['地図']} url={symbolDetail.LocationMapURL!} />
        </div>
        <DomesticRealEstateSubLabel data={symbolDetail.SalesPlotAnnotationText!} />
      </div>
    </div>
  );
};

type DomesticRealEstateMainLabelDataProps = {
  headList: string[];
  dataList: string[];
};

type DomesticRealEstateSubLabelProps = {
  data: string;
};

const DomesticRealEstateMainLabel = ({ headList, dataList }: DomesticRealEstateMainLabelDataProps) => {
  return (
    <div className="mainLabel_row">
      <div className="mainLabel_row_head">
        {headList.map((head) => (
          <div>{head}</div>
        ))}
      </div>
      <div className="mainLabel_row_data">
        {dataList.map((data) => (
          <div>{data}</div>
        ))}
      </div>
    </div>
  );
};

type DomesticRealEstateMainLabelMapProps = {
  headList: string[];
  url: string;
};
const DomesticRealEstateMainMap = ({ headList, url }: DomesticRealEstateMainLabelMapProps) => {
  return (
    <div className="mainLabel_row">
      <div className="mainLabel_row_head">
        {headList.map((head) => (
          <div>{head}</div>
        ))}
      </div>
      <div className={'mainLabel_row_map'}>
        <iframe src={url} className={'mainLabel_row_map'} loading="lazy"></iframe>
      </div>
    </div>
  );
};
const DomesticRealEstateSubLabel = ({ data }: DomesticRealEstateSubLabelProps) => {
  return (
    <div className="subLabel">
      <div className="subLabel_data">{data}</div>
    </div>
  );
};

export const OverseasRealEstateFullInfo = (symbolDetail: OverseasRealEstateSymbolDetailInfo) => {
  return (
    <div className="overseasRealEstate">
      <div className="fullInfo">
        <OverseasRealEstateSubData {...symbolDetail} />
      </div>
    </div>
  );
};

const OverseasRealEstateSubData = ({
  PaLDistMonth,
  InitialYearExpenseRate,
  DurationOfPartnership,
  CompletionYear,
  BuildingType,
  MinimumInvestmentAmount,
  BuildingName,
  Location,
}: OverseasRealEstateSymbolDetailInfo) => {
  const regex = /\d{1,2}日/g;
  return (
    <>
      <div className="subData">
        <div className="subData_head">
          <span>損益分配日（※1）</span>
          <span>初年度損金算入率（想定）</span>
          <span>組合存続期間</span>
        </div>
        <div className="subData_data">
          <span>{PaLDistMonth + '末'}</span>
          <span>{InitialYearExpenseRate}</span>
          <span>{DurationOfPartnership}</span>
        </div>
        <div className="subData_head">
          <span>竣工年</span>
          <span>建物用途</span>
          <span>最低出資額</span>
        </div>
        <div className="subData_data">
          <span>{CompletionYear}</span>
          <span>{BuildingType}</span>
          <span>{formatYenBasedOn10KYen(MinimumInvestmentAmount)}</span>
        </div>
        <div className="subData_large">
          <div className="subData_large_head">物件名</div>
          <div className="subData_large_data">{BuildingName}</div>
          <div className="subData_large_head">所在地</div>
          <div className="subData_large_data">{Location}</div>
        </div>
      </div>
    </>
  );
};

export const OverseasRealEstateInitialYearExpenseRate = (symbolDetailInfo: OverseasRealEstateSymbolDetailInfo) => {
  return (
    <>
      <div className="topic">
        <div className="topic_label">初年度損金算入率（想定）</div>
        <div className="topic_date">{symbolDetailInfo.InitialYearExpenseRate}</div>
      </div>
    </>
  );
};

export const FinalBusinessProfitRate = (symbolDetailInfo: OverseasRealEstateSymbolDetailInfo) => {
  return (
    <>
      <div className="topic">
        <div className="topic_label">最終事業損益率（想定）</div>
        <div className="topic_date">{symbolDetailInfo.FinalBusinessProfitRate}</div>
      </div>
    </>
  );
};

export const HoldingPeriod = (symbolDetailInfo: OverseasRealEstateSymbolDetailInfo) => {
  return (
    <>
      <div className="topic">
        <div className="topic_label">保有期間</div>
        <div className="topic_date">{symbolDetailInfo.HoldingPeriod}</div>
      </div>
    </>
  );
};
